'use strict';

function CompanyCustomerServiceTypeService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/service-types/:serviceTypeId', {}, {
    'update':  {
      method: 'PUT'
    },
    'delete': {
      method: 'DELETE'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyCustomerServiceTypeService', ['$resource', 'config', CompanyCustomerServiceTypeService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/customers/service-type/CompanyCustomerServiceTypeService.js
// module id = 337
// module chunks = 0